import * as actions from '../actions/setUserPassword';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';


export function postUserSetPassword(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_POST_USER_SET_PASSWORD)
        .map(action => ({
            url: BASE_URL + 'api/AdminManageUsers/Password',
            category: 'postUserSetPassword',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postUserSetPassword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePostUserSetPassword(response.text));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponseUserSetPassword(sources) {
    let httpResponse$ = sources.HTTP
        .select('postUserSetPassword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveBadRequestPostUserSetPassword(response));

    return {
        ACTION: httpResponse$
    };
}